import cookie from '../utils/cookie';

declare global {
  const HUBSPOT_APP_ID: string;
  const WEBPACK_API: string;
  const WEBPACK_TW_PRD_API: string;
  const WEBPACK_TW_STG_API: string;
  const WEBPACK_TW_DEV_API: string;
  const WEBPACK_APP: string;
  const GOOGLE_API_KEY: string;
  const GOOGLE_OAUTH_CLIENT_ID: string;
  const SIGNUP_RECAPTCHA_SITE_KEY: string;
}

const isProd = process.env.SENDIBLE_ENV === 'production';
const proxysrv = cookie('proxysrv').get();
const twBaseUrl = isProd
  ? `https://${WEBPACK_TW_PRD_API}`
  : proxysrv?.includes('dev-be-tw')
    ? `https://${WEBPACK_TW_DEV_API}`
    : `https://${WEBPACK_TW_STG_API}`;

export default {
  baseUrl: `https://${WEBPACK_API}`,
  twBaseUrl,
  appBaseUrl: `https://${WEBPACK_APP}`,
  hubspotScripts: `https://js.hs-scripts.com/${HUBSPOT_APP_ID}.js`,
  hubspotForms: 'https://js.hsforms.net/forms/v2.js',
  firstPromoter: 'https://cdn.firstpromoter.com/fprom.js',
  signupUrl: `https://${WEBPACK_API}/1.2/api/signup`,
  hubspotSignupStyles: 'https://2235233.fs1.hubspotusercontent-na1.net/hubfs/2235233/Signup%20Assets/2022/style.css',
  hubspotSignupScript: 'https://2235233.fs1.hubspotusercontent-na1.net/hubfs/2235233/Signup%20Assets/2022/script.js',
  connectAPI: `https://${WEBPACK_API}/api/v2/connect`,
};
